import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { NODE_HANDLE_IDS } from '@containers/flow/nodes';
import { Body5 } from '@ui';
import styled from 'styled-components';
import { colorPalette } from '@theme';

const SHOW_NAME_HANDLE_STYLE = {
  top: '108px',
  right: '4px',
  zIndex: 1000,
};
const DEFAULT_HANDLE_STYLE = {
  top: '15px',
  right: '6px',
  zIndex: 1000,
};
const Wrapper = styled.div`
  position: relative;
`;
const Label = styled.div`
  position: absolute;
  top: 99px;
  right: 14px;
  pointer-events: none;

  text-transform: uppercase;
  letter-spacing: -0.3px;

  * {
    font-size: 12px !important;
    color: ${colorPalette.secondary.orange};
  }
`;

export default React.memo(({ data, showName, isConnectable }) => {
  const id = NODE_HANDLE_IDS.outputAggregation;
  const name = 'Output Aggregation';

  if (showName) {
    return (
      <Wrapper>
        {showName && (
          <Label>
            <Body5 bold uppercase>
              {name}
            </Body5>
          </Label>
        )}
        <Handle
          type="source"
          id={id}
          position={Position.Right}
          style={{
            background: colorPalette.secondary.orange,
            cursor: isConnectable ? undefined : 'not-allowed',
            ...SHOW_NAME_HANDLE_STYLE,
          }}
          onConnect={(params) => console.log('handle onConnect', params)}
          isConnectable={isConnectable}
          isConnectableStart={isConnectable}
        />
      </Wrapper>
    );
  }
  return (
    <Handle
      type="source"
      id={id}
      position={Position.Right}
      style={{
        background: colorPalette.secondary.orange,
        cursor: isConnectable ? undefined : 'not-allowed',
        ...DEFAULT_HANDLE_STYLE,
      }}
      onConnect={(params) => console.log('handle onConnect', params)}
      isConnectable={isConnectable}
      isConnectableStart={isConnectable}
    />
  );
});
